var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutsidehome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7728 16.0003C12.5961 15.5011 15 13.8428 15 11.5C15 9.567 13.433 8 11.5 8C9.567 8 8 9.567 8 11.5C8 13.8428 10.4039 15.5011 11.2272 16.0003C11.3969 16.1032 11.6031 16.1032 11.7728 16.0003ZM11.5 14C12.8807 14 14 12.8807 14 11.5C14 10.1193 12.8807 9 11.5 9C10.1193 9 9 10.1193 9 11.5C9 12.8807 10.1193 14 11.5 14Z",
    fill: "currentcolor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4907 21.2739C11.667 21.2739 11.8989 21.1997 12.1123 21.0791C17.3076 18.0732 19.0239 16.9414 19.0239 13.75V6.69922C19.0239 5.70654 18.6528 5.38184 17.7993 5.03857C16.4819 4.50977 13.5503 3.42432 12.2329 2.96973C11.9917 2.88623 11.7412 2.83057 11.4907 2.83057C11.2402 2.83057 10.999 2.89551 10.7578 2.96973C9.44043 3.39648 6.50879 4.51904 5.19141 5.03857C4.33789 5.37256 3.9668 5.70654 3.9668 6.69922V13.75C3.9668 16.9414 5.70166 18.0454 10.8784 21.0791C11.0825 21.1997 11.3237 21.2739 11.4907 21.2739ZM11.4907 20.0029C11.3423 20.0029 11.166 19.9287 10.9526 19.7896C6.64795 17.1177 5.10791 16.3477 5.10791 13.5273V6.9126C5.10791 6.44873 5.19141 6.28174 5.54395 6.14258C6.77783 5.65088 9.81152 4.56543 11.0454 4.08301C11.2217 4.00879 11.3794 3.97168 11.4907 3.97168C11.6021 3.97168 11.7598 4.01807 11.936 4.08301C13.1792 4.56543 16.1943 5.68799 17.4468 6.14258C17.7993 6.27246 17.8828 6.44873 17.8828 6.9126V13.5273C17.8828 16.3477 16.3242 17.0991 12.0381 19.7896C11.8154 19.9287 11.6484 20.0029 11.4907 20.0029Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutsidehome);
export default __webpack_public_path__ + "static/media/Outside home.b355b9ba61293214682efe2a6ddd83be.svg";
export { ForwardRef as ReactComponent };